module.exports = __webpack_public_path__ + "static/media/yellow02.66db1c9f.svg";